import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
var GradientTextField = styled(TextField)(function (_a) {
    var theme = _a.theme;
    return {
        "& .MuiInputBase-root": {
            padding: '12px',
            background: 'transparent',
            border: "solid 1.3px ".concat(theme === null || theme === void 0 ? void 0 : theme.palette.primary.main),
            borderRadius: 20,
            '& fieldset.MuiOutlinedInput-notchedOutline': {
                borderColor: 'transparent'
            },
        },
        "& .MuiInputBase-input": {
            background: 'transparent',
            padding: 0
        }
    };
});
export default GradientTextField;
